import app from 'flarum/forum/app';
import updateDiscussionDetail from './updateDiscussionDetail';

app.initializers.add('dvdfab/discussiondetail', () => {
  
  updateDiscussionDetail()
});
